<template>
  <div :class="['sub-header', { 'sub-header--sticky': sticky }]">
    <div class="sub-header__container">
      <div class="sub-header__top">
        <div class="sub-header__title-area">
          <h2 class="sub-header__title">{{ title }}</h2>
          <div v-if="subtitle" class="sub-header__subtitle">{{ subtitle }}</div>
        </div>
        <div v-if="$slots.actions" class="sub-header__actions">
          <slot name="actions" />
        </div>
      </div>
      <slot name="below-title" />
      <Tabs
        v-if="tabs?.length"
        v-model="activeTab"
        :tabs="tabs"
        class="nav-bordered mt-2"
        data-testid="sub-header-tabs" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Tabs } from '@prospective/lithium';

export interface SubHeaderTab {
  label: string;
  value: string | number;
  icon?: string;
  badge?: string;
  badgeClass?: string;
  isLoading?: boolean;
}

interface Props {
  title: string;
  subtitle?: string;
  tabs?: SubHeaderTab[];
  sticky?: boolean;
}

defineProps<Props>();
const activeTab = defineModel<string>('activeTab', { default: '' });
</script>

<style scoped>
.sub-header {
  background-color: #fff;
  border-bottom: 1px solid var(--tblr-border-color, #e6e7e9);
}

.sub-header--sticky {
  position: sticky;
  top: 85px;
  z-index: 1029;
}

.sub-header__container {
  padding: 0 1.25rem;
}

.sub-header__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.sub-header__title {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  font-family: var(--font-brand);
  margin: 0;
}

.sub-header__subtitle {
  font-size: 14px;
  color: #475467;
  margin-top: 2px;
}

.sub-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
